export default __webpack_public_path__ + "slices/main/assets/public/media/product/platform/platform-feature-employee@2x.030fb52fa8ad4a1a6393652b75568dd5.png";